export default "__VITE_ASSET__DSLuMou3__"